define([
    "jquery",
    "underscore",
    "marionette",
    "models/member_model",
    "behaviors/form_errors_behavior",
    "templates/open_account/survey_alert_message.html",
    "templates/open_account/survey_error_message.html",
    "moment",
    "bootstrap.datepicker",
    "backbone.syphon",
    "jquery.fileupload",
    "holdon"
], function($, _, Marionette, MemberModel, FormErrorsBehavior, surveyAlertMessage, surveyErrorMessage, moment) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui:{
            'step0': '#step0',
            'step1': '#step1',
            'step2': '#step2',
            'step3': '#step3',
            'step4': '#step4',
            'surveyBtn': '#survey_btn',
            'surveyList': '.survey',
            'complete': '#complete',
            'nextStepBtn': '.next_step',
            'previousStepBtn': '.previous_step',
            'submitBtn': '.submit_button',
            'birthDatePicker': '#birth',
            'signatureStep2': '#signature_step2',
            'signatureNameStep2': '#signature_step2_name',
            'signatureStep3': '#signature_step3',
            'signatureNameStep3': '#signature_step3_name',
            'signatureStep4': '#signature_step4',
            'signatureNameStep4': '#signature_step4_name',
            'pleFile': '#ple_file',
            'pleName': '#ple_name',
            'ple': '#ple',
            'poaFile': '#poa_file',
            'poaName': '#poa_name',
            'poa': '#poa',
            'registrationOption': '#registration_option',
            'ukRegistrationOption' : '#uk_registration_option',
            'signatures': '.signature_box',
            'promotionPopup': '#promotion_popup',
            'promotionAgree': 'input[name=promotion_agree]',
            'promotionCd': '#promotion_cd',
            'leverage': '#leverage'
        },

        events:{
            'change @ui.surveyList': 'resetSurveyPassed',
            'change @ui.ukRegistrationOption': 'redirectUser',
			'change @ui.registrationOption': 'redirectUser',
            'click @ui.nextStepBtn': 'nextStep',
            'click @ui.previousStepBtn': 'previousStep',
            'click @ui.submitBtn': 'submit',
            'keyup @ui.signatureNameStep2': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureNameStep2, this.ui.signatureStep2);
            },
            'keyup @ui.signatureNameStep3': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureNameStep3, this.ui.signatureStep3);
            },
            'keyup @ui.signatureNameStep4': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureNameStep4, this.ui.signatureStep4);
            },
            'change @ui.promotionCd': 'updateLeverageList'
        },

        // Different promotions have different available leverages, let's update it here.
        updateLeverageList: function(){
            var optionsString = "", currentSelected = this.ui.leverage.val();

            this.ui.leverage.html("");
            _.each(window.leverages[this.ui.promotionCd.val()], function(item, index){
                optionsString += "<option value='" + index + "'>" + item + "</option>";
            });
            this.ui.leverage.append(optionsString);
            if(+currentSelected > +this.ui.leverage.find('option').last().val()){
                this.ui.leverage.find('option').last().prop('selected', 'selected');
            }else{
                this.ui.leverage.find('option[value='+currentSelected+']').prop('selected', 'selected');
            }
        },

        resetSurveyPassed: function(e) {
            this.surveyPassed = false;
        },

        surveyPassed: true,

		redirectUser: function(e) {
			e.preventDefault();

			var accountType = $(e.currentTarget).val();
			var targetUrl = [this.redirectUrl, accountType].join('/')+window.location.search;
			if(history.replaceState){
				history.replaceState({}, document.title, targetUrl);
			}
			window.location = targetUrl;
		},

		fillSignatureBox: function() {
			var name = (this.model.get('registration_option') == 'corporate') ?
                        this.model.get('company_name') :
                        this.model.get('first_name') + ' ' + this.model.get('last_name');
			this.ui.signatures.val(name);
		},

        validation: {
		    step0: [
                'how_often_security',
                'how_often_futures',
                'how_often_forex',
                'employment_stat',
                'annual_income',
                'value_of_savings',
                'exp_position_of_derivatives',
                'exp_seminar_of_derivatives',
                'exp_qualification_of_derivatives'
            ],

            step1: [
                'registration_option',
				'company_name',
                'first_name',
                'last_name',
                'gender',
                'citizenship_country_cd',
                'birth',
                'email',
                'address_country_cd',
                'phone_area',
                'phone_country',
                'phone_rest',
                'currency_cd',
                'leverage',
                'mobile_country',
                'mobile_area',
                'mobile_rest',
                'address_province',
                'address_city',
                'address_rest',
                'address_zip'
            ],
            step2: [
                'referral_ib',
                'net_worth',
                'annual_income',
                'employment_status',
                'industry_cd',
                'exp_fx',
                'exp_stock',
                'exp_futures',
                'exp_option',
                'exp_bond',
                'ple',
                'poa',
                'signature_step2'
            ],
            step3: [
                'signature_step3',
                'consent_step3'
            ],
            step4: [
                'signature_step4',
                'consent_step4'
            ]
        },

        initialize: function(){
            this.bindUIElements();

            this.redirectUrl = window.redirect_url || baseUrl+'open_account/live_account';

            this.model = new MemberModel();

            this.step = 0;
            this.changeStep(this.step, this.step + 1);

            if("corporate" == this.ui.registrationOption.val()){
                this.ui.birthDatePicker.datetimepicker({
                    viewMode: 'years',
                    format: 'YYYY-MM-DD',
                    // Can't be in the future
                    maxDate: moment()
                });
            }else{
                this.ui.birthDatePicker.datetimepicker({
                    viewMode: 'years',
                    format: 'YYYY-MM-DD',
                    // We need to be 20years old to register to let's have the max date be 20years from now
                    maxDate: moment().subtract(18, 'y')
                });
            }

            this.initFileUpload(this.ui.pleFile, 'ple');
            this.initFileUpload(this.ui.poaFile, 'poa');
        },

        initFileUpload: function($selector, type){
            var that = this;
            $selector.fileupload({
                url: '/rest_open_account/'+type,
                dataType: 'json',
                // File selected, put the original name in the textbox
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });
                    data.submit();
                },
                // Upload success, put the server-side name in the hidden input
                done: function(e, data){
                    that.ui[type+'Name'].val(data.files[0].name);
                    that.ui[type].val(data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                // Upload failed, display error + remove name from textbox
                fail: function(e,data){
                    var errors = {};
                    errors[type] = data.jqXHR.responseJSON.error_msg;

                    that.ui[type+'Name'].val('');
                    that.ui[type].val('');

                    that.triggerMethod('show:errors', errors);

                    HoldOn.close();
                }
            });
        },

        updateSignature: function($signatureName, $signature){
            // Filter all characters that are not a-z A-Z
            $signatureName.val($signatureName.val().replace(/[^a-zA-Z0-9\s\-\_\,\.]/g, function(str){
                return '';
            }));

            $signature.val($signatureName.val());
        },

        showPromotionPopup: function(){
            var that = this, d = $.Deferred();

            if(0 < this.ui.promotionPopup.length && window.popup_promotion_cd == this.ui.promotionCd.val() ){
                this.ui.promotionPopup.modal({
                    backdrop: 'static',
                    keyboard: false,
                    show: true
                });

                // On popup close, check the answer
                this.ui.promotionPopup.on('hidden.bs.modal', function(e){
                    // Agree
                    if(that.ui.promotionAgree[0].checked){
                        d.resolve();
                    }else if(that.ui.promotionAgree[1].checked){
                        // Disagree
                        d.reject();
                    }
                    that.ui.promotionPopup.off();
                });
            }else{
                d.resolve();
            }

            return d.promise();
        },

        previousStep: function(e){
            if(e) e.preventDefault();

            this.changeStep(this.step, this.step-1);
        },

        nextStep: function(e){
            if(e) e.preventDefault();

            HoldOn.open({
                theme:"sk-fading-circle"
            });
			var that = this;
			this.fillSignatureBox();

            $.when(
                this.checkCurrentStepValid()
            ).done(function(){
                if( 1 == that.step) {
                    $.when(
                        that.showPromotionPopup()
                    ).done(function(){
                        that.changeStep(that.step, that.step + 1);
                    }).fail(function(){
                        that.triggerMethod('show:errors', {promotion_cd: "Please choose a different promotion."});
                    });
                }else{
                    that.changeStep(that.step, that.step + 1);
                }
            }).always( function(){
                HoldOn.close();
            });
        },

        changeStep: function(previousStep, newStep){
			this.hideStep(previousStep);
			this.showStep(newStep);
			this.step = newStep;
        },

        hideStep: function(step){
            this.ui['step'+step].hide();
        },

        showStep: function(step){
            this.ui['step'+step].show();
            // Scroll to the top of the new active step
            $('html, body').animate({
                scrollTop: this.ui['step'+step].offset().top
            }, 0);
        },

        showComplete: function(step){
            if( ciEnv == 'production' && ciEntity != 'gd_global') {
                window.fbq('track', 'CompleteRegistration');
                if( typeof accountType != 'undefined' && accountType == 'ecn') {
                    window.ga( 'set', 'page', '/open_account/ecn_account/complete');
                    window.ga( 'send', 'pageview');
                    fbq('track', '<ecnaccount>');
                } else {
                    window.ga( 'set', 'page', '/open_account/live_account/complete');
                    window.ga( 'send', 'pageview');
                    fbq('track', '<liveaccount>');
                }
            }

            this.ui.complete.show();
            // Scroll to the top of the new active step
            $('html, body').animate({
                scrollTop: this.ui.complete.offset().top
            }, 0);
        },

        checkCurrentStepValid: function(lastStep){
            lastStep = lastStep || false;

            var that = this;

            this.triggerMethod('hide:errors');
            var formData = Backbone.Syphon.serialize(this);

            this.model.set(formData);
            // For corporate accounts, citizenship_country_cd = address_country_cd
			if( this.model.get('registration_option') == 'corporate')
				this.model.set( 'citizenship_country_cd', this.model.get('address_country_cd'));

            var errors = {};
            if(!lastStep){
                // Validate the current step
                errors = this.model.isValid(this.validation['step' + this.step], true);
            }else{
                // Validate the entire model
                errors = this.model.isValid(true, true);
            }

            var d = $.Deferred();

            if(!errors){
                if( this.surveyPassed) {
                    // Check with the server
                    if(!lastStep){
                        this.model.url = this.model.urlRoot + '/step' + this.step;
                    }else{
                        this.model.url = this.model.urlRoot;
                    }

                    return this.model.save(null, {
                        // Use this to bypass calling validate(). validate() tries to check the entire object but we already
                        // handled validating what we needed to earlier.
                        forceUpdate: true,
                        type: 'POST',
                        success: function(model, response){
                        },
                        error: function(model, error){
                            that.triggerMethod('show:errors', error.responseJSON);
                        }
                    });
                } else {
                    switch( this.doSurvey()) {
                        case 'success':
                            this.surveyPassed = true;
                            this.nextStep();
                            break;
                        case 'alert':
                            this.surveyPassed = true;
                            d.reject();
                            break;
                        case 'error':
                            this.surveyPassed = false;
                            d.reject();
                            break;
                    }
                }
            }else{
                d.reject();
                this.triggerMethod('show:errors', errors);
            }

            return d.promise();
        },

        doSurvey: function() {
            var sum;
            sum = parseInt(this.$('#how_often_security').val())
                + parseInt(this.$('#how_often_futures').val())
                + parseInt(this.$('#how_often_forex').val())
                + parseInt(this.$('#employment_stat').val())
                + parseInt(this.$('#annual_income').val())
                + parseInt(this.$('#value_of_savings').val())
                + parseInt(this.$('#exp_position_of_derivatives').val())
                + parseInt(this.$('#exp_seminar_of_derivatives').val())
                + parseInt(this.$('#exp_qualification_of_derivatives').val());

            var riskSum = 0;
            riskSum = parseInt(this.$('#how_often_security').val())
                + parseInt(this.$('#how_often_futures').val())
                + parseInt(this.$('#how_often_forex').val())
                + parseInt(this.$('#exp_position_of_derivatives').val())
                + parseInt(this.$('#exp_seminar_of_derivatives').val())
                + parseInt(this.$('#exp_qualification_of_derivatives').val());

            if( riskSum <= 0 ) {
                errorMessage =  surveyErrorMessage();
                this.triggerMethod('show:errors', {error_message: errorMessage});
                return 'error';
            } else {
                if (sum > 0 && sum <= 8) {
                    errorMessage =  surveyAlertMessage();
                    this.triggerMethod('show:errors', {error_message: errorMessage});
                    return 'alert';
                }
            }

            return 'success';
        },

        submit: function(e){
            if(e) e.preventDefault();

            HoldOn.open({
                theme:"sk-fading-circle"
            });

            var that = this;

            $.when(
                this.checkCurrentStepValid(true)
            ).done(function(){
                that.hideStep(that.step);
                that.showComplete();

                // Some cleanup
                delete that.model;
                delete that.step;
            }).always( function(){
                HoldOn.close();
            });
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/open_account/live_account_view.js
// module id = 32
// module chunks = 0